import { ONE_HOUR_SEC } from '@glass/common/modules/dates/constants';
import { BASE_PATH_2_QUERY } from '@glass/common/modules/pages/queryParams';
import { TEMPLATES_SECTION } from '@glass/web/modules/resumes/router/sections';

import TemplateSelectorPage from '@glass/shared/components/ResumeBuilder/pages/templates/TemplateSelectorPage';
import createBuilderGetStaticPaths from '@glass/shared/modules/resumes/createBuilderGetStaticPaths';
import createBuilderGetStaticProps from '@glass/shared/modules/resumes/createBuilderGetStaticProps';
import { RESUME_BUILDER_LANDING_BASE_PATHS } from '@glass/shared/modules/router/resumeBuilderBasePaths';

export const getStaticPaths = createBuilderGetStaticPaths({
  resumeBuilderBasePaths: RESUME_BUILDER_LANDING_BASE_PATHS,
});

export const getStaticProps = createBuilderGetStaticProps({
  revalidate: 6 * ONE_HOUR_SEC,
  [BASE_PATH_2_QUERY]: TEMPLATES_SECTION,
});

export default TemplateSelectorPage;
